import l10n from '../../../shared/strings';
import { navigate } from '../../../helpers/history';

const strings = l10n.ACTIONS_TOOLBAR.PRODUCTS;

const STORE_DISCONNECTED_SUBCODE = 'StoreDisconnectedApiError';

export const isStoreDisconnectedError = (error) => {
  const status = Number(error?.response?.status);
  const subcode = error?.response?.data?.subcode || error?.subcode;
  return status === 409 && subcode === STORE_DISCONNECTED_SUBCODE;
};

export default function handleStoreDisconnectedError({ Toast, error } = {}) {
  const message = error?.response?.data?.msg
    || error?.message
    || strings.storeDisconnected;

  Toast(message, {
    type: 'error',
    autoClose: false,
    btnOkValue: strings.reconnectChannel,
    onOk: () => navigate('/teammates?tab=channels'),
  });
}
